import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0586a58e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rate-pie-wrap" }

import { nextTick, onUnmounted, PropType, ref, watch, onMounted } from 'vue'
import * as echarts from 'echarts'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ResizeService } from '@/services/resize.service'
import { getItemGradient } from '@/utils/echarts-tool/pie'
import { getElColorPrimary } from '@/utils/theme-color'
import { getCssColorVar } from '@/utils/chart-theme-colors'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'rate-pie',
  props: {
  value: {
    type: Number,
    default: 0
  },
  valueClick: {
    type: Function as PropType<() => void>,
  },
  title: {
    type: String,
    default: '占比'
  },
  color: {
    type: String,
    default: '',
  },
  shadowColor: {
    type: String,
    // 中性默认值在 getChartOption 中经 getCssColorVar 运行时适配深色模式
    default: '#E4ECF4',
  },
  radius: {
    type: Array as PropType<String[]>,
    default: () => ['72%', '90%'],
  }
},
  setup(__props) {

const props = __props

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartNode = ref<HTMLElement>()
let chartInstance: echarts.EChartsType

function createChart () {
  if (!chartNode.value) {
    return
  }
  chartInstance = echarts.init(chartNode.value, null)
}

function renderChart () {
  if (!chartInstance) {
    return
  }

  chartInstance.setOption(getChartOption())
}

function getChartOption () {
  const primaryColor = props.color || getElColorPrimary()
  // 中性浅色阴影随深色模式变暗（canvas 不支持 var()，运行时读取）
  const shadowColor = (props.shadowColor === '#E4ECF4' || props.shadowColor === '#F0F0F0')
    ? getCssColorVar('--cm-color-border-light', props.shadowColor)
    : props.shadowColor
  return {
    series: [
      {
        type: 'pie',
        radius: props.radius,
        data: [{
          label: { show: false, },
          value: props.value,
          itemStyle: {
            color: getItemGradient(primaryColor, 0.6, [1, 1, 0, -1.5]),
            shadowColor,
            shadowBlur: 4,
            shadowOffsetY: 4,
          },
        }, {
          label: { show: false, },
          value: 100 - props.value,
          itemStyle: { color: getCssColorVar('--cm-color-hover-bg', '#F0F0F0') },
        }]
      }
    ]
  }
}

function initChart () {
  chartInstance && chartInstance.dispose()
  createChart()
  renderChart()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  nextTick(() => chartInstance && chartInstance.resize())
})

useEchartsThemeSync(() => {
  if (chartInstance) renderChart()
})

onMounted(() => {
  nextTick(initChart)
})

watch(() => props.value, () => {
  nextTick(initChart)
}, { immediate: true })

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "chartNode",
      ref: chartNode,
      class: "chart"
    }, null, 512),
    _createVNode(PieCenter, {
      title: __props.title,
      unit: "%",
      value: __props.value,
      click: __props.valueClick
    }, null, 8, ["title", "value", "click"])
  ]))
}
}

})